import React from "react";
import { Progress } from "@/components/ui/progress";
import { Check } from "lucide-react";

export const Stepper = ({ steps, current }) => {
  const pct = Math.round(((current + 1) / steps.length) * 100);
  return (
    <div
      className="sticky top-16 z-20 border-b border-white/10"
      style={{ backgroundColor: "rgba(10,10,11,0.95)" }}
      data-testid="assessment-stepper"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs uppercase tracking-widest text-[#66B2FF] font-semibold">
            Step {current + 1} of {steps.length}
          </span>
          <span className="text-xs text-white/50">{pct}% complete</span>
        </div>
        <Progress
          value={pct}
          data-testid="assessment-progress-bar"
          className="h-2 bg-white/10"
        />
        <div className="hidden md:flex items-center justify-between mt-4">
          {steps.map((s, i) => {
            const done = i < current;
            const active = i === current;
            return (
              <div key={s.key} className="flex items-center gap-2">
                <span
                  className={`h-6 w-6 rounded-full flex items-center justify-center text-[11px] font-semibold border ${
                    active
                      ? "bg-[#1E6BFF] border-[#1E6BFF] text-white"
                      : done
                      ? "bg-[#1E6BFF]/20 border-[#1E6BFF]/40 text-[#66B2FF]"
                      : "border-white/15 text-white/40"
                  }`}
                >
                  {done ? <Check size={12} /> : i + 1}
                </span>
                <span
                  className={`text-xs ${
                    active ? "text-white" : "text-white/45"
                  }`}
                >
                  {s.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Stepper;
